<template>
  <div class="privacy-policy" :class="{ 'mobile': isMobile, 'desktop': !isMobile }">
    <h1>プライバシーポリシー</h1>
    <p>メノア株式会社（以下「当運営者」といいます。）は、当運営者が管理するサービス「ナイミー（nimee）」（以下「本サービス」といいます。）におけるユーザーの情報の取り扱いについて、以下の通りプライバシーポリシー（以下「本ポリシー」といいます。）を定めます。</p>

    <h2>1. 本サービスの特徴とデリケートな情報の取り扱い</h2>
    <p>本サービスは、夫婦・カップル（以下「パートナー」といいます。）の間で、夜の誘い・応答に関する気持ちや温度感を共有するためのアプリです。本サービスは、性生活に関わるデリケートな情報を取り扱います。</p>
    <ul>
      <li>ユーザーが入力した誘い・応答の内容は、本サービス上でペアとして連携したパートナーに対してのみ共有されます。</li>
      <li>当運営者は、これらの内容を本サービスの提供および後述の目的の範囲を超えて利用することはありません。</li>
      <li>当運営者は、通常の利用において、ユーザーの氏名・住所・電話番号等の登録を求めません。ただし、データ引き継ぎの準備およびデータ復元機能を利用する場合には、AppleまたはGoogleの認証サービスを通じたアカウント連携が必要となります。</li>
    </ul>

    <h2>2. 当運営者が取得する情報</h2>
    <p>本サービスの提供にあたり、当運営者は以下の情報を取得します。</p>
    <ul>
      <li><strong>匿名アカウント識別子</strong>：本サービスは会員登録不要でご利用いただけます。サービス提供のため、匿名認証により自動的に割り当てられる識別子を取得します。ユーザーがアカウント連携を行わない限り、氏名・メールアドレス等の個人情報とは紐づきません。</li>
      <li><strong>アカウント連携に関する情報</strong>：ユーザーがデータ引き継ぎの準備またはデータ復元機能を利用する場合、AppleまたはGoogleの認証サービスを通じて、連携した認証プロバイダの種別、プロバイダ側のユーザー識別子、認証に利用したメールアドレス、Firebase Authentication上の認証情報を取得・処理します。</li>
      <li><strong>ペアリングおよびやり取りの情報</strong>：パートナー連携のための招待コード、連携情報、および誘い・応答の内容（気分、できること、理由などユーザーが選択・入力した内容）。これらはサービス提供のためサーバー上に保存されます。</li>
      <li><strong>購入およびサブスクリプションに関する情報</strong>：プレミアム機能の提供、購入状態の確認、購入の復元、ペアへのプレミアム共有のため、AppleまたはGoogleのアプリ内課金情報、RevenueCatが発行・処理する購入イベント、サブスクリプションの有効・失効状態、Firebase Authentication上のユーザー識別子とRevenueCat上のアプリユーザー識別子を取得・処理します。クレジットカード番号等の決済手段情報は、各プラットフォームまたは決済事業者により処理され、当運営者が取得・保存することはありません。</li>
      <li><strong>プッシュ通知トークン</strong>：パートナーからの通知をお届けするための、デバイスのプッシュ通知トークン。</li>
      <li><strong>カメラ映像</strong>：パートナー連携時にQRコードを読み取るためにカメラを使用します。映像はQRコードの読み取りのためにユーザーのデバイス上でのみ処理され、当運営者のサーバーに送信・保存されることはありません。顔データ等を取得・処理することはありません。</li>
      <li><strong>利用状況・不具合に関する情報</strong>：サービス改善およびアプリの安定性向上を目的として、個人を特定できない形式のクラッシュレポートや利用統計情報を取得する場合があります。</li>
    </ul>

    <h2>3. 情報の利用目的</h2>
    <p>当運営者は取得した情報を以下の目的で利用いたします。</p>
    <ul>
      <li>本サービスの提供（誘い・応答の送受信、パートナーへの通知の配信）のため</li>
      <li>パートナー連携機能の提供のため</li>
      <li>データ引き継ぎの準備、データ復元、アカウント連携状態の管理のため</li>
      <li>プレミアム機能の提供、購入状態の確認、購入の復元、無料利用枠の管理、ペアへのプレミアム共有のため</li>
      <li>不正利用の防止、本人確認補助、認証に関する安全性確保のため</li>
      <li>本サービスの品質向上および不具合の改善のため</li>
      <li>本サービスの利用状況の分析のため</li>
    </ul>

    <h2>4. パートナーへの情報の共有</h2>
    <p>ユーザーが入力した誘い・応答の内容は、本サービス上で連携したパートナーに共有されます。パートナー連携が成立する前、および連携を解除した後は、これらの内容が共有されることはありません。</p>

    <h2>5. 第三者への情報提供および業務委託</h2>
    <ul>
      <li>当運営者は、法令に基づく場合を除き、取得した情報を第三者に提供することはありません。</li>
      <li>当運営者は、本サービスの提供のため、認証・データベース・プッシュ通知・分析等の機能についてGoogle社が提供する「Firebase」を利用しています。これに伴い、上記の情報は同社のサーバーに保存・処理される場合があります。</li>
      <li>当運営者は、データ引き継ぎの準備およびデータ復元機能における認証のため、Apple社およびGoogle社が提供する認証サービスを利用します。</li>
      <li>当運営者は、プレミアム機能の購入状態の管理、購入の復元、サブスクリプション状態の確認および当該状態の本サービスへの反映のため、RevenueCat, Inc.が提供するサービスを利用します。RevenueCatには、Firebase Authentication上のユーザー識別子、購入イベント、サブスクリプションの有効・失効状態等が送信・処理される場合があります。</li>
      <li>当運営者は、AppleまたはGoogleから送信されるアプリ内課金に関する通知、およびRevenueCatから送信されるWebhookを利用して、プレミアム状態を本サービスのデータベースに反映する場合があります。</li>
    </ul>

    <h2>6. 情報の保存と削除</h2>
    <p>当運営者は、取得した情報を本サービスの提供に必要な期間保存します。ユーザーは、パートナー連携の解除、本サービスのアンインストール、アカウント連携の解除、または下記お問い合わせ窓口へのご連絡により、情報の削除を求めることができます。</p>

    <h2>7. お問い合わせ</h2>
    <p>本ポリシーに関するお問い合わせは、以下のメールアドレス宛にご連絡ください。</p>
    <p>info@menoah.jp</p>

    <h2>8. プライバシーポリシーの改定</h2>
    <p>当運営者は、必要に応じて本ポリシーを改定することがあります。改定後のポリシーは、本サービス上または当運営者のウェブサイトに掲載した時点から効力を生じるものとします。</p>

    <p>2026年6月5日制定<br>2026年6月23日改定</p>
  </div>
</template>

<script>
export default {
  name: 'NimeePrivacyPolicyView',
  data() {
    return {
      isMobile: false
    }
  },
  mounted() {
    document.title = 'プライバシーポリシー | ナイミー';
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth < 768;
    }
  }
};
</script>

<style scoped>
/* 共通スタイル - 見出し設定 */
h1 {
  color: var(--color-green-600);
}

h2 {
  font-size: 20px;
  color: var(--color-grey-500);
  margin-top: 32px;
}

p, li {
  color: var(--color-grey-500);
}

/* モバイル対応スタイル */
.mobile {
  padding-top: 56px;
  padding-bottom: 56px;
  padding-left: 24px;
  padding-right: 24px;
}

.mobile h1 {
  font-size: 24px;
  margin-bottom: 20px;
  text-align: left;
}

.mobile h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 16px;
}

.mobile p, .mobile li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.mobile ul {
  margin-bottom: 15px;
  padding-left: 20px;
}

.mobile li {
  margin-bottom: 5px;
}

/* デスクトップ対応スタイル */
.desktop {
  padding-top: 120px;
  padding-bottom: 120px;
  padding-left: 80px;
  padding-right: 80px;
  max-width: 1120px;
  margin: 0 auto;
}

.desktop h1 {
  font-size: 28px;
  padding-bottom: 24px;
  text-align: left;
}

.desktop h2 {
  font-size: 20px;
  margin-top: 56px;
  margin-bottom: 24px;
}

.desktop p, .desktop li {
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 15px;
}

.desktop ul {
  margin-bottom: 20px;
  padding-left: 20px;
}

.desktop li {
  margin-bottom: 8px;
}
</style>
